import React, { Component, PropTypes } from 'react';

import {
  NitroHeading,
  NitroDivider,
  NitroLoading,
  NitroDrawer,
  NitroPlaceholder
} from 'nitro-components';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../actions';

import { DriverDetailsCard } from '../../../../components/driver';

import { getFormattedDate } from '../../helper';
import {
  ALLOCATION_DETAIL_HEADING,
  ALLOCATION_INFO_REGISTRATION,
  ALLOCATION_INFO_LEASEID,
  DRIVERS_HISTORY,
  ALLOCATION_INFO_DIFFERENT_DRIVER,
  DASHBOARD_LINK
} from '../content';

import PastDrivers from './PastDrivers';

class VehicleDriverDetails extends Component {
  /** onCurrentDriverPanelClick = driverId => {
    this.props.onCurrentDriverPanelClick(driverId);
  };
  * */

  getDriverStartDate = () => {
    const { DriverAllocations } = this.props.driverAllocationDetails;

    if (!DriverAllocations || !DriverAllocations.length) {
      return '';
    }

    return getFormattedDate(DriverAllocations[0].StartDate, 'DD/MM/YYYY');
  };

  render() {
    const {
      isOpen,
      close,
      driverAllocationDetails,
      fetchingDriverAllocationDetails,
      redirectedDriverProfile
    } = this.props;

    let driverDetails = null;

    if (driverAllocationDetails) {
      const {
        DriverFirstName,
        DriverSurname,
        RegistrationNumber,
        LeaseId,
        DriverAllocations,
        DriverId
      } = driverAllocationDetails;

      const vehicleInfo = [
        {
          title: ALLOCATION_INFO_REGISTRATION,
          description: RegistrationNumber
        },
        {
          title: ALLOCATION_INFO_LEASEID,
          description: LeaseId
        }
      ];

      driverDetails = fetchingDriverAllocationDetails ? (
        <NitroLoading position="center" />
      ) : (
        <section>
          <NitroHeading
            label={ALLOCATION_DETAIL_HEADING}
            size="1"
            variant="secondary"
          />

          <DriverDetailsCard
            DriverFullName={`${DriverFirstName} ${DriverSurname}`}
            DriverTitleMessage={`Allocated on ${
              DriverAllocations && DriverAllocations.length > 0
                ? getFormattedDate(DriverAllocations[0].StartDate, 'DD/MM/YYYY')
                : ''
            }`}
            onButtonClick={this.props.onAllocateDifferentDriverClick}
            driverId={DriverId}
            buttonText={ALLOCATION_INFO_DIFFERENT_DRIVER}
            redirectedDriverProfile={redirectedDriverProfile}
            route={DASHBOARD_LINK}
          />

          <NitroHeading
            size="1"
            label={DRIVERS_HISTORY}
            align="center"
            noMargin
          />
          <NitroDivider sidePanel />
          <PastDrivers list={DriverAllocations || []} />
        </section>
      );
    } else {
      driverDetails = (
        <div>
          <NitroPlaceholder size={40} />
          <NitroHeading
            size="1"
            variant="base3"
            label="Allocation Details not present for the Driver"
            align="center"
          />
          <NitroPlaceholder size={20} />
        </div>
      );
    }

    return (
      <NitroDrawer
        isOpen={isOpen}
        padding="32px"
        width={460}
        close={() => {
          close('vehicleAllocation');
        }}
      >
        {driverDetails}
      </NitroDrawer>
    );
  }
}

VehicleDriverDetails.propTypes = {
  actions: PropTypes.object,
  isOpen: PropTypes.bool,
  close: PropTypes.func,
  onCurrentDriverPanelClick: PropTypes.func,
  onAllocateDifferentDriverClick: PropTypes.func,
  fetchingQuoteSummary: PropTypes.bool,
  driverAllocationDetails: PropTypes.object,
  vehicleDetails: PropTypes.object,
  fetchingDriverAllocationDetails: PropTypes.bool,
  country: PropTypes.object,
  redirectedDriverProfile: PropTypes.object
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

VehicleDriverDetails.defaultProps = {
  driverAllocationDetails: null,
  vehicleDetails: null,
  fetchingDriverAllocationDetails: true,
  fetchingQuoteSummary: true,
  redirectedDriverProfile: null,
  country: null,
  isOpen: false,
  close: () => {},
  onAllocateDifferentDriverClick: () => {},
  onCurrentDriverPanelClick: () => {},
  actions: null
};
export default connect(null, mapDispatchToProps)(VehicleDriverDetails);



// WEBPACK FOOTER //
// ./src/features/relocations/driver/components/VehicleDriverDetails.js